/* drl-klaviyo-scrollfix — a gorgetes visszaadasa a Klaviyo felugro utan.

   A BAJ, MERVE

   A Klaviyo a `body`-ra teszi a `klaviyo-prevent-body-scrolling` osztalyt,
   amikor felugrot nyit, es bezaraskor NEM mindig veszi le. Merve 2026-08-27-en
   az ELO teman, 390px-es nezeten, a Gerincbarat parna lapjan:

     betoltes utan     body.overflow = "clip visible"    gorgetheto
     felugro nyitva    body.overflow = "hidden"          zarva
     BEZARAS UTAN      body.overflow = "hidden"          ZARVA MARADT

   A vevo tehat megnyitja a 20% kedvezmenyt, bezarja, es onnantol nem tud
   gorgetni a termeklapon. Ez nem kozmetika: a termeklap alja -- a leiras, a
   velemenyek, a GYIK -- elerhetetlen lesz.

   MIERT A TEMABAN

   Az app JS-ehez nem nyulunk, es nem is tudnank. Amit a tema tud: eszreveszi,
   hogy az osztaly ott van, holott felugro NEM latszik, es leveszi. A zarat
   tehat nem hatastalanitjuk -- amig a felugro all, marad -- csak a mogotte
   felejtett allapotot takaritjuk el.

   MIERT NINCS ALLANDO setInterval

   Egy orokke futo idozito minden lapon dolgozna, holott a hiba csak akkor
   letezik, amikor az osztaly felkerult. Ezert: figyeljuk a `body` osztalyat,
   es CSAK amikor felkerul, indul az ellenorzes, ami leall, amint az osztaly
   eltunt.

   A 60 MASODPERCES LYUK -- MERVE 2026-09-11

   Az elso valtozat egy perc utan onmagat leallitotta. Aki a felugrot egy
   percnel tovabb hagyta nyitva (olvasott, appot valtott, e-mailt gepelt), es
   utana zarta be, annak a lap VEGLEG zarva maradt: a Klaviyo bezaraskor nem
   nyul az osztalyhoz, tehat az observer nem sult el, es semmi nem elesztette
   ujra a figyelot. Merve az ELO teman, 390px, 70 mp nyitva tartas utan
   bezarva: +8 mp-nel is `body.overflow = hidden`. Ezert: nincs idokorlat, amig
   az osztaly fent van; es a figyelo ujraeled minden olyan jelre, ami egy
   visszatero vagy epp bezaro latogatohoz tartozik. */
(function () {
  var CLS = 'klaviyo-prevent-body-scrolling';
  var POLL_MS = 400;
  var timer = null;

  /* AZ ELEM SAJAT STILUSA NEM ELEG -- MERVE.

     Bezaras utan a Klaviyo a KULSO burkot teszi `opacity: 0`-ra, a belso
     `.klaviyo-form` pedig `opacity: 1`, `display: flex`, 371x332 marad. Az elso
     valtozat csak az elem sajat stilusat nezte, tehat "meg latszik"-ot mondott,
     es nem vette le az osztalyt. A javitas a javitason: az OSOKET is vegig kell
     jarni. */
  function effectivelyVisible(el) {
    if (el.checkVisibility) {
      try {
        return el.checkVisibility({
          opacityProperty: true,
          visibilityProperty: true,
          contentVisibilityAuto: true
        });
      } catch (e) { /* regi bongeszo: esik a kezi bejarasra */ }
    }
    var node = el;
    while (node && node.nodeType === 1) {
      var cs = getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity || '1') < 0.05) return false;
      node = node.parentElement;
    }
    return true;
  }

  function popupVisible() {
    var nodes = document.querySelectorAll('.klaviyo-form,[data-testid="POPUP"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var box = el.getBoundingClientRect();
      if (box.width < 120 || box.height < 120) continue;
      if (!effectivelyVisible(el)) continue;
      return true;
    }
    return false;
  }

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  /* A SZELLEM-BUROK -- MERVE 2026-09-11, iPhone Safari

     A termeklapon a bezart felugro fixed burka BENT MARAD: z-index 90000,
     teljes nezet, opacity 0, pointer-events auto. Az osztaly mar lekerult, a
     window.scrollTo mukodik -- de az ujj a burkon landol, aminek nincs
     gorgetheto ose, tehat a Safari nem gorget semmit. A headless meres ezert
     nem fogta meg: a programozott gorgetes megkeruli az ujj alatti elemet.
     Nem toroljuk a csomopontot (a Klaviyo meg elbonthatja), csak az erintest
     engedjuk at rajta. Ami meg latszik, ahhoz nem nyulunk. */
  function clearGhostOverlays() {
    var nodes = document.querySelectorAll('div[class*="kl-private-reset-css"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      var b = el.getBoundingClientRect();
      if (b.width < window.innerWidth * 0.8 || b.height < window.innerHeight * 0.8) continue;
      if (parseFloat(cs.opacity || '1') >= 0.05) continue;
      /* Csak a burokra teve nem eleg: a gyerekei pointer-events: auto-val
         ujra elkapjak az erintest. Merve. A jelolo + a stilus-szabaly a
         teljes reszfat zarja. */
      el.setAttribute('data-drl-ghost', '');
    }
  }
  var style = document.createElement('style');
  style.textContent = '[data-drl-ghost],[data-drl-ghost] *{pointer-events:none!important}';
  document.head.appendChild(style);

  function release() {
    document.body.classList.remove(CLS);
    stop();
    clearGhostOverlays();
    setTimeout(clearGhostOverlays, 600);
  }

  function check() {
    if (!document.body.classList.contains(CLS)) { stop(); return; }
    if (!popupVisible()) release();
    /* A felugro meg all: figyelunk tovabb. Az intervallum csak addig el, amig
       az osztaly a body-n van, tehat nem fut orokke. */
  }

  function arm() {
    if (!document.body.classList.contains(CLS)) return;
    if (timer) return;
    timer = setInterval(check, POLL_MS);
  }

  new MutationObserver(arm).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  /* Ha a lap ugy erkezik, hogy az osztaly mar rajta van -- visszalepes,
     bfcache -- az observer nem sul el. */
  arm();
  /* A Klaviyo sajat esemenye a legmegbizhatobb jel: bezaraskor `close`
     tipussal sul el. Nem varunk a kovetkezo poll-ra. */
  window.addEventListener('klaviyoForms', function (e) {
    var t = e.detail && e.detail.type;
    if (t === 'close') release();
  });
  window.addEventListener('pageshow', arm);
  /* Hatterbe tett fulon a bongeszo lassitja az idozitot; visszateres, fokusz
     es az elso erintes ujra bekapcsol, ha az osztaly meg ott van. */
  document.addEventListener('visibilitychange', arm);
  window.addEventListener('focus', arm);
  document.addEventListener('pointerdown', arm, { passive: true });
  document.addEventListener('touchstart', arm, { passive: true });
})();
